import { type UserInfoType } from "../models/profile/user-info";
import { type RoomAvatarType } from "../models/secure-chat";
import { addressShorten } from "./wallet";

// ROOM BASIC INFO
const getUserBasicInfo = (
  user: UserInfoType | null,
  getDisplayName: (user: UserInfoType | null) => string
): {
  displayName: string;
  walletAddress: string;
  nftAvatarUrl: string;
  avatarUrl: string;
  avatars: RoomAvatarType[];
} => {
  if (!user)
    return {
      displayName: "",
      walletAddress: "",
      nftAvatarUrl: "",
      avatarUrl: "",
      avatars: [],
    };
  const displayName =
    getDisplayName(user) ?? addressShorten(user?.wallet_address);
  const walletAddress = user?.wallet_address ?? "";
  const nftAvatarUrl =
    user?.nft_avatar?.animation_url ?? user?.nft_avatar?.avatar_url ?? "";
  const avatarUrl = user?.avatar?.url ?? user?.avatar?.avatar_url ?? "";
  const avatars = [{ nftAvatarUrl, avatarUrl, walletAddress }];

  return { displayName, walletAddress, nftAvatarUrl, avatarUrl, avatars };
};

export { getUserBasicInfo };
